import React, { useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

function OrderStatus({ orderId }) {
  const [orderDetails, setOrderDetails] = useState(null);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleFetchOrder = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`/api/gelato/orders/${orderId}`);
      setOrderDetails(response.data);
      setIsError(false);
    } catch (error) {
      console.error('Error fetching order:', error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="order-status">
      <input
        type="text"
        value={orderId}
        onChange={(e) => setOrderId(e.target.value)}
        placeholder="Enter Order ID"
      />
      <button onClick={handleFetchOrder}>Check Status</button>

      {isLoading && <div className="loading-spinner"></div>}

      {isError && <p className="error">Failed to fetch order. Please try again.</p>}

      {orderDetails && (
        <div className="order-details">
          <h3>Order ID: {orderDetails.id}</h3>
          <p>Status: {orderDetails.status}</p>
          {/* Display more order details as needed */}
        </div>
      )}
    </div>
  );
}

OrderStatus.propTypes = {
  orderId: PropTypes.string,
};

export default OrderStatus;
